/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Work_Plan_ExpandInputs */



/**
* | output |
* | --- |
* | "Show plan" |
*
* @param {Chat_Work_Plan_ExpandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_work_plan_expand = /** @type {((inputs?: Chat_Work_Plan_ExpandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Work_Plan_ExpandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Plan anzeigen")
	return /** @type {LocalizedString} */ ("Show plan")
});